export default __webpack_public_path__ + "static/media/proposicao_imi.13358a59.png";